import { useAppSelector } from '../..'
import { type ISurveyTemplate } from '../../../models/SurveyTemplate'

export const getStudentSelectedSurvey = (): ISurveyTemplate | null => useAppSelector((state) => state.studentDistributions.studentSelectedSurvey)
export const getIsLoading = (): boolean => useAppSelector((state) => state.studentDistributions.isLoading)
export const getIsSubmitting = (): boolean => useAppSelector((state) => state.studentDistributions.isSubmitting)
export const getPublicSurveyLoadError = (): string | null => useAppSelector((state) => state.studentDistributions.publicSurveyLoadError)
